import { FC } from 'react';
import { MultiSelect } from '@features/ui';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { ProductFormData } from '@src/types';
import { tradingPlatFormsData } from '@features/admin/productsAddons/productsAddonsData';
import { cn } from '@lib/utils.ts';

interface ProductCompatibleDataFeedsProps {
  control: Control<ProductFormData>;
  errors: FieldErrors<ProductFormData>;
  className?: string;
}
export const ProductCompatibleDataFeeds: FC<
  ProductCompatibleDataFeedsProps
> = ({ control, errors, className }) => {
  return (
    <Controller
      control={control}
      name="compatible_data_feeds"
      render={({ field }) => (
        <div className={cn(className, 'flex flex-1 flex-col gap-2')}>
          <p>Select 1 or more Data Feeds that it works with</p>
          <MultiSelect
            error={!!errors.compatible_data_feeds?.message}
            options={tradingPlatFormsData}
            value={field.value}
            onChange={(value) => field.onChange(value)}
          />
        </div>
      )}
    />
  );
};
